var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.797 2.805c.005-.275-.103-.54-.299-.735-.195-.194-.461-.3-.737-.294-.272-.004-.535.104-.725.298-.19.195-.293.46-.283.732v2.188c0 .041-.025.078-.063.094s-.082.007-.111-.021L1.647.214C1.418-.015.877-.176.341.361c-.395.326-.456.908-.136 1.309l4.86 4.905c.03.029.038.073.022.11-.016.039-.053.064-.094.064H2.727c-.565 0-1.023.458-1.023 1.023s.458 1.022 1.023 1.022h5.661c.226 0 .41-.183.41-.409v-5.58z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRisk);
export default __webpack_public_path__ + "static/media/low-risk.93d18f18b2e8c36f655ca31685fa0b1f.svg";
export { ForwardRef as ReactComponent };